import React, { useState, useRef, useEffect } from 'react';
import logo from '../../assets/images/logo.jpg';
import logoMini from '../../assets/images/logo-mini.jpg';
import {
  FaUserFriends,
  FaUserTie,
  FaRegStar,
  FaAngleLeft,
  FaAngleRight,
  FaHome,
  FaUser,
  FaMapMarkedAlt,
  FaVideo,
  FaUsers,
  FaSubscript,
  FaExclamationCircle,
  FaRupeeSign,
  FaUserCircle,
  FaWhatsapp,
  FaAngleDown,
  FaAngleUp,
  FaStar,
  FaDotCircle,
} from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToBreadcrumbs } from '../../redux/breadcrumSlice';
import { isOpenSideBar } from '../../redux/commonSlice';
import { isMobileSideBar } from '../../redux/mobileSideBar';
import { IoNewspaper, IoDocumentTextOutline } from 'react-icons/io5';
import {
  MdAddAlert,
  MdAutoGraph,
  MdCurrencyRupee,
  MdOutlineFeed,
  MdOutlineGroups,
  MdOutlineVideoLibrary,
} from 'react-icons/md';
import { FaBookAtlas, FaBookTanakh, FaGear } from 'react-icons/fa6';
import { PiBankDuotone } from 'react-icons/pi';
import Cookies from 'js-cookie';
import { getActiveCourseMasterMenu } from '../../service/admin/adminCourses.service';
import { studentCourseMainMenu } from '../../service/student/studentCourses.service';

export default function SideBar(props: { data?: any }) {
  const dispatch = useDispatch();
  const sideOpen: any = useRef();
  const sidebarOpen = useSelector((state: any) => state.commonSlice);
  const mobileSideBar = useSelector((state: any) => state.mobileSideBar);
  const [loginData, setLoginData] = useState<any>(undefined);
  const [openDropdowns, setOpenDropdowns] = useState<{ [key: string]: boolean }>({});
  const [courseMenuItems, setCourseMenuItems] = useState<any>([]);
  const location = useLocation();
  const fetchCourseMenu = async()=>{
    const fetch = await getActiveCourseMasterMenu();
    if(fetch?.status === "success"){
     if(fetch?.message.length > 0){
      let newData:any= [];
      fetch?.message.map((item:any)=>{
        newData.push(
           {name: item?.name, link: "/admin/courses?filter="+item?.slug,slug:item?.slug, icon: null,category:item.courseCategory},
        )
      })
      setCourseMenuItems(newData);
     }
    }
  }
  const fetchStudentCourseMainMenu = async()=>{
    const fetch = await studentCourseMainMenu();
    if(fetch?.status === "success"){
     if(fetch?.message.length > 0){
      let newData:any= [];
      fetch?.message.map((item:any)=>{
        newData.push(
           {name: item?.name, link: "/student/courses?filter="+item?.slug,slug:item?.slug, icon: null,category:item.courseCategory},
        )
      })
      setCourseMenuItems(newData);
     }
    }
  }
  useEffect(() => {
   if(props.data === "admins"){
    fetchCourseMenu()
   }
   if(props.data === "student"){
    fetchStudentCourseMainMenu()
   }
  },[])
  let navItem: any = [];
  if (props.data === 'admins') {
    navItem = [
      { name: 'Dashboard', link: '/admin/dashboard', icon: FaHome },
      { name: 'Batches', link: '/admin/batches', icon: MdOutlineGroups },
      
      // Display first 2 course menu items directly
      ...(courseMenuItems.length > 0 ? 
          courseMenuItems.slice(0, 2).map((item:any) => ({
              name: item.name,
              link: item.link,
              slug: item.slug,
              icon: null,
            subItem: item.category.length > 0 && item.category.map((cat:any)=>{
              return {
                name: cat.name,
              link: `/admin/courses?filter=${item.slug}&category=${cat.slug}`,
              slug: cat.slug,
              icon: null,
              }
            })
          })) : []
      ),
      // Add "More Courses" with remaining items if needed
      ...(courseMenuItems.length > 2 ? [{
        name: 'More Courses',
        link: '#',
        icon: FaBookTanakh,
        subItem: courseMenuItems.slice(2)
      }] : []),
      {
        id: 3, 
        name: 'All Courses', 
        link: '/admin/courses', 
        icon: FaBookTanakh
      },
      { name: 'Videos', link: '/admin/videos', icon: MdOutlineVideoLibrary },
      { name: 'Test Series', link: '/admin/test-series', icon: IoNewspaper },
      { name: 'Live Classes', link: '/admin/live-class', icon: FaVideo },
      { name: 'Students', link: '/admin/students', icon: FaUserFriends },
      {
        name: 'Installments',
        link: '/admin/installments',
        icon: MdCurrencyRupee,
      },
      { name: 'Exam Alerts', link: '/admin/exam-alert', icon: MdAddAlert },
      { name: 'Feeds', link: '/admin/feeds', icon: MdOutlineFeed },
      { name: 'Promotions', link: '/admin/promotions', icon: MdAutoGraph },
      { name: 'Payments', link: '/admin/payments', icon: PiBankDuotone },
      {
        name: 'Pending Payments',
        link: '/admin/payment/pending',
        icon: FaRupeeSign,
      },
      {
        name: 'Students Devices',
        link: '/admin/student-devices',
        icon: FaStar,
      },
      {
        name: 'Setting',
        link: '/admin/setting',
        icon: FaGear,
       
      },
    ];
  }
  if (props.data === 'superAdmin') {
    navItem = [
      { name: 'Dashboard', link: '/super-admin/dashboard', icon: FaHome },
      { name: 'Center', link: '/super-admin/centers', icon: FaMapMarkedAlt },
      { name: 'Admins', link: '/super-admin/admins', icon: FaUsers },
    ];
  }
  if (props.data === 'student') {
    navItem = [
      { name: 'Dashboard', link: '/student/dashboard', icon: FaHome },
     
      // Display first 2 course menu items directly
      ...(courseMenuItems.length > 0 ? 
          courseMenuItems.slice(0, 2).map((item:any) => ({
              name: item.name,
              link: item.link,
              slug: item.slug,
              icon: null,
            subItem: item.category.length > 0 && item.category.map((cat:any)=>{
              return {
                name: cat.name,
              link: `/student/courses?filter=${item.slug}&category=${cat.slug}`,
              slug: cat.slug,
              icon: null,
              }
            })
          })) : []
      ),
      // Add "More Courses" with remaining items if needed
      ...(courseMenuItems.length > 2 ? [{
        name: 'More Courses',
        link: '#',
        icon: FaBookTanakh,
        subItem: courseMenuItems.slice(2)
      }] : []),
       { name: 'All Courses', link: '/student/courses', icon: FaBookTanakh },
      { name: 'Videos', link: '/student/videos', icon: MdOutlineVideoLibrary },
      { name: 'Test Series', link: '/student/test-series', icon: IoNewspaper },
      { name: 'Live Classes', link: '/student/live-class', icon: FaVideo },
      {
        name: 'Exam Alert',
        link: '/student/exam-alert',
        icon: FaExclamationCircle,
      },
      {
        name: 'My Subscription',
        link: '/student/subscription',
        icon: FaBookAtlas,
      },
      {
        name: 'Pending Payments',
        link: '/student/payment/hold',
        icon: FaRupeeSign,
      },
      {
        name: 'Logged Devices',
        link: '/student/devices',
        icon: FaStar,
      },
    ];
  }

  useEffect(() => {
    // Handle basic path-based navigation items
    let m: any = navItem.find(
      (item: any) => {
        // Basic path matching
        const basePath = `/${item.link.split('/')[1]}/${item.link.split('/')[2]}`;
        const currentBasePath = `/${location.pathname.split('/')[1]}/${location.pathname.split('/')[2]}`;
        
        // Direct match for basic routes
        if (basePath === currentBasePath && !item.slug) {
          // For pages without filters, check if the path is exactly the same
          if (!location.search || item.link.includes(location.search)) {
            return true;
          }
        }
        
        // For course items with slug, check if the slug matches the filter parameter
        if (item.slug) {
          const urlParams = new URLSearchParams(location.search);
          const filterParam = urlParams.get('filter');
          return filterParam === item.slug;
        }
        
        return false;
      }
    );

    // If not found in main items, check in More Courses submenu
    if (!m && courseMenuItems.length > 4) {
      const moreCourses = courseMenuItems.slice(4);
      const urlParams = new URLSearchParams(location.search);
      const filterParam = urlParams.get('filter');
      
      m = moreCourses.find((item: any) => item.slug === filterParam);
    }

    if (m) {
      dispatch(
        addToBreadcrumbs({
          name: m?.name,
          path: m?.link,
        })
      );
    }
  }, [location, navItem, courseMenuItems, dispatch]);

  useEffect(() => {
    let data: any = Cookies.get('login');
    setLoginData(JSON.parse(data));
    const handleClickOutside = (event: any) => {
      if (sideOpen.current && !sideOpen.current.contains(event.target)) {
        dispatch(isMobileSideBar(false));
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileSideBar]);

  const handleBreadcrum = (item: any) => {
    // dispatch(isMobileSideBar(false));
  };

  const handleSideBarStatus = () => {
    dispatch(isOpenSideBar(!sidebarOpen));
  };

  const toggleDropdown = (name: string) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const isActiveRoute = (link: string, subItems?: any[], slug?: string) => {
  const currentPath = location.pathname;
  const currentSearch = location.search;
  const urlParams = new URLSearchParams(currentSearch);
  const filterParam = urlParams.get('filter');
  const categoryParam = urlParams.get('category');
  
  // Handle course menu items with filter parameters
  if (slug) {
    // Check if it's a category slug (subitem)
    if (categoryParam === slug) {
      return true;
    }
    
    // Check if it's a course slug (main item)
    if (filterParam === slug && !categoryParam) {
      return true;
    }
  }
  
  // For main Courses link - should be active only when there's no filter or category
  if (link.endsWith('/courses')) {
    // Main Courses link should be active only if we're on the courses page with no filter
    if (currentPath === link && !filterParam && !categoryParam) {
      return true;
    }
    return false;
  }
  
  // Regular path matching for non-course routes
  if (currentPath === link && !currentSearch) return true;
  
  // Check subItems if present
  if (subItems && subItems.length > 0) {
    return subItems.some(subItem => {
      // For category subitems
      if (subItem.slug) {
        // If this is a category subitem, check if category param matches its slug
        const subItemUrlParams = new URLSearchParams(new URL(subItem.link, window.location.origin).search);
        const subItemFilterParam = subItemUrlParams.get('filter');
        const subItemCategoryParam = subItemUrlParams.get('category');
        
        return filterParam === subItemFilterParam && categoryParam === subItemCategoryParam;
      }
      
      // Regular subitem path matching
      if (typeof subItem === 'string') return currentPath === subItem;
      return currentPath === subItem.link;
    });
  }
  
  return false;
};

  const renderNavItems = (items: any[], isMobile: boolean = false) => {
    
    return items.map((e: any, i: any) => (
      <div key={i} className="relative">
        <NavLink
          to={e?.link}
          className={`flex items-center justify-between w-[100%] dark:text-gray-300 rounded-md text-gray-200 my-2 
            ${isActiveRoute(e.link, e.subItem, e.slug) && 'activeNavItem'}`}
          end={false}
        >
          <div
            onClick={() => {
              handleBreadcrum(e);
              e.subItem && toggleDropdown(e.name);
            }}
            className="hover:cursor-pointer flex flex-col justify-start mb-2 w-full"
          >
            <div className={`py-2 flex flex-row gap-2 mt-[5%] w-full items-center justify-between`}>
              <div className='flex items-center justify-start gap-3'>
                <div id="active-icon" className="pl-2">
                  {e?.icon !== null ? (
                    <div id="active-icon" className="text-dark dark:text-white">
                      {e?.icon ? React.createElement(e?.icon, { size: '20' }) : null}
                    </div>
                  ) : (
                    <FaRegStar className="text-2xl text-dark" />
                  )}
                </div>
                <p className={` ${sidebarOpen ? 'block font-medium' : 'hidden'} text-dark dark:text-white`}>
                  {e.name}
                </p>
              </div>
              {e.subItem && e.subItem.length > 0 && (
                sidebarOpen ? (
                  openDropdowns[e.name] ? <FaAngleUp className='mr-3 text-dark' /> : <FaAngleDown className='mr-3 text-dark' />
                ) : null
              )}
            </div>
          </div>
        </NavLink>

        {/* Dropdown for sub-items */}
        {e.subItem && e.subItem.length > 0 && openDropdowns[e.name] && sidebarOpen && (
          <div className="p-2 mt-[-0.5rem] w-[98%]">
            {e.subItem.map((subItem: any, subIndex: number) => (
              <NavLink
                key={subIndex}
                to={subItem.link}
                className={({ isActive }) => 
                  `pl-4 py-2 gap-2 flex items-center justify-start text-sm mb-1 ${
                    isActiveRoute(subItem.link, undefined, subItem.slug) && 'activeNavItem' 
                  }`
                }
              >
                <FaStar /> {subItem.name}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    ));
  };
  return (
    <>
      <aside
        className={` ${sidebarOpen ? 'w-[17%]  md:w-[22%] lg:w-[17%]' : 'w-auto'} fixed z-20 hidden sm:hidden  md:block lg:block dark:bg-dark-purple bg-gray-100 h-[100vh] overflow-y border-r-4  overflow-scroll`}
      >
        <div className="flex justify-center flex-col w-full p-1">
          {sidebarOpen ? (
            <>
              <div className="flex justify-center">
                <img
                  src={loginData ? logo : logo}
                  className={` w-[170px]  my-2`}
                  alt=""
                />
              </div>
              {loginData ? (
                <p className="text-center dark:text-white text-dark font-bold text-xl">
                  {loginData?.name}
                </p>
              ) : null}
            </>
          ) : (
            <img src={logoMini} className={` w-[50px]  my-2`} alt="" />
          )}
        </div>
        <div id="sidebar" className="navItems mt-10 md:mt-5  w-full">
          {navItem.length > 0 ? renderNavItems(navItem) : null}
        </div>
        <div>
          {sidebarOpen ? (
            <FaAngleLeft
              onClick={() => handleSideBarStatus()}
              className="fixed top-[3vh] left-[16%] lg:left-[16%] md:left-[20%] bg-white h-8 w-8 rounded-full p-1 shadow-lg hover:cursor-pointer hover:bg-gray-800 hover:text-white"
            />
          ) : (
            <FaAngleRight
              onClick={() => handleSideBarStatus()}
              className="fixed top-[3vh] left-[4%] md:left-[6%] lg:left-[4%] bg-white h-8 w-8 rounded-full p-1 shadow-lg hover:cursor-pointer hover:bg-gray-800 hover:text-white"
            />
          )}
        </div>
      </aside>
      
      {/* Mobile Sidebar */}
      <aside
        ref={sideOpen}
        className={`${mobileSideBar ? 'block fixed z-20 w-[50%] bg-gray-100 h-[100vh] overflow-auto dark:bg-dark-blue' : 'hidden'}`}
      >
        <div className="">
          <div className="flex justify-center h-[10vh]">
            <img src={logo} className=" h-[50px] my-2" alt="" />
          </div>
          <div id="sidebar" className="navItems mt-10 md:mt-5 ">
            {navItem.length > 0 ? renderNavItems(navItem, true) : null}
          </div>
        </div>
      </aside>
    </>
  );
}